import React, { useEffect, useState } from 'react'
import { verifyNullValue } from '@auteco/utils/verifyNullValue'
import { Button, Dialog, DialogContent, DialogTitle, IconButton, TextField, Typography } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import DeleteIcon from '@material-ui/icons/Delete';
import { deleteGroupFromProfile, deleteUserFromProfile } from '@auteco/services/snopServices';
import { Alert } from '@auteco/components/snopComponents/Alert'
import { initialAlert } from '@auteco/constants';
import useStyles from './styles'

const DialogConsultProfile = ({ profiles, open, onClose, getProfiles }) => {
    const [profile, setProfile] = useState()
    const [type, setType] = useState('')
    const [alertInfo, setAlertInfo] = useState(initialAlert)

    const optionsFilter = [{ name: 'Grupo', value: 'grupo' }, { name: 'Usuarios', value: 'usuario' }]
    const classes = useStyles()


    const onCloseAlert = () => {
        setAlertInfo(initialAlert)
    }

    const onSelectProfile = ({ id }) => {
        if (id !== '') {
            const newProfile = profiles.find(prof => prof.id === id)
            setProfile(newProfile)
        } else {
            setType('')
            setProfile()
        }
    }

    const onDeleteElement = async ({ id, elementType }) => {
        if (elementType === 'grupo') {
            const body = {
                perfil_id: profile.id,
                grupo_id: id
            }
            const { success } = await deleteGroupFromProfile({ params: body })
            if (success === 1) {
                getProfiles()
            }
        } else if (elementType === 'usuario') {
            const body = {
                perfil_id: profile.id,
                usuario_id: id
            }
            const { success } = await deleteUserFromProfile({ params: body })
            if (success === 1) {
                getProfiles()
            }
        }
        setAlertInfo(initialAlert)
    }

    const onDelete = ({ id, elementType }) => {
        setAlertInfo({ title: '¡Espera!', content: `Estás a punto de eliminar este ${type} del perfil, ¿deseas continuar?`, textBtn1: 'Cerrar', textBtn2: 'Continuar', open: true, onClose: onCloseAlert, funcBtn: () => onDeleteElement({ id, elementType }) })
    }

    const handleClose = () => {
        onClose()
        setType('')
        setProfile()
    }

    useEffect(() => {
        if (profile) {
            const newProfile = profiles.find(prof => prof.id === profile.id)
            setProfile(newProfile)
        }
    }, [profiles])
    return (
        <>
            <Alert
                title={alertInfo.title}
                content={alertInfo.content}
                textBtn1={alertInfo.textBtn1}
                textBtn2={alertInfo.textBtn2}
                funcBtn={alertInfo.funcBtn}
                open={alertInfo.open}
                onClose={onCloseAlert}
            />
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Consultar perfil</DialogTitle>
                <DialogContent className={classes.dialogContent}>
                    <Autocomplete
                        options={profiles}
                        className={classes.textField}
                        getOptionLabel={(option) => option.nombre}
                        renderInput={(params) => <TextField {...params} label="Perfiles" variant='outlined' />}
                        onChange={(e, newValue) => onSelectProfile({ id: verifyNullValue({ value: newValue, param: 'id' }) })}
                    />
                    <Autocomplete
                        options={optionsFilter}
                        className={classes.textField}
                        disabled={!profile}
                        getOptionLabel={(option) => option.name}
                        renderInput={(params) => <TextField {...params} label="Buscar asignación de" variant='outlined' />}
                        onChange={(e, newValue) => setType(verifyNullValue({ value: newValue, param: 'value' }))}
                    />
                    {
                        type === 'grupo' ?
                            <>
                                {profile.grupos?.length > 0 ?
                                    <>
                                        <Typography className={classes.elemetsTitle}>Nombre de los grupos</Typography>
                                        <div className={classes.elementsContainer}>
                                            {profile.grupos.map(group =>
                                                <div className={classes.element}>
                                                    {/* <Checkbox color='primary' onChange={(e, isChecked) => onSelectMaterial({ isChecked, material })} /> */}
                                                    <p className={classes.elementTxt}>{group.nombre}</p>
                                                    <IconButton onClick={() => onDelete({ id: group.id, elementType: 'grupo' })}>
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </div>

                                            )}
                                        </div>
                                    </>
                                    :
                                    <Typography>No hay grupos asignados a este perfil</Typography>
                                }
                            </>
                            :
                            type === 'usuario' &&
                            <>
                                {profile.usuarios?.length > 0 ?
                                    <>
                                        <Typography className={classes.elemetsTitle}>Nombre de los usuarios</Typography>
                                        <div className={classes.elementsContainer}>
                                            {profile.usuarios.map(user =>
                                                <div className={classes.element}>
                                                    {/* <Checkbox color='primary' onChange={(e, isChecked) => onSelectMaterial({ isChecked, material })} /> */}
                                                    <p className={classes.elementTxt}>{user.nombre}</p>
                                                    <IconButton onClick={() => onDelete({ id: user.user_id, elementType: 'usuario' })}>
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </div>

                                            )}
                                        </div>
                                    </>
                                    :
                                    <Typography>No hay usuarios asignados a este perfil</Typography>
                                }
                            </>
                    }
                </DialogContent>
                <Button variant='contained' className={classes.closeBtn} onClick={handleClose}>Volver</Button>
            </Dialog>
        </>
    )
}

export { DialogConsultProfile }